module.exports = __webpack_public_path__ + "images/ds-cm2024-projects.webp";